const PROD = import.meta.env.PROD;

export class Logger {
  prefix?: string;
  constructor(prefix: string) {
    this.prefix = ` [${prefix}]` || "";
  }
  log(...args: any[]) {
    console.log(`${new Date().toISOString()} [LOG]${this.prefix} `, ...args);
  }
  warn(...args: any[]) {
    console.log(`${new Date().toISOString()} [WARN]${this.prefix} `, ...args);
  }
  error(...args: any[]) {
    console.log(`${new Date().toISOString()} [ERROR]${this.prefix} `, ...args);
    if(!PROD)
      throw new Error(args[0]);
  }
}